<!-- 新闻 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_news.png"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="公益事件报道" en="PUBLIC WELFARE REPORT"></sub-title>
        <div class="list" v-if="list.length != 0">
          <div
            class="item"
            v-for="item in list"
            :key="item.id"
            @click="getDetail(item)"
          >
            <div class="info">
              <div class="top">
                <div class="title">{{ item.title }}</div>
                <div class="time">
                  {{ (item.publishTime || item.createTime) | handleTime }}
                </div>
              </div>
              <div class="desc">{{ item.description }}</div>
            </div>
            <div class="post">
              <img :src="URL + img" v-for="img in item.imgArr" :key="img" />
            </div>
          </div>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="queryParams.pageIndex"
            :page-size="queryParams.pageSize"
            layout="total, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
        <el-empty description="暂无案例" v-else></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
import { URL } from "@/util/config";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      URL,
      routerHistory: [], // 当前所在位置
      subNavs: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        newsCode: "0cec2c4bb968455696e338ab1ce8c9cd",
      },
      list: [],
      total: 0,
      bannerList: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.getList();
    this.formatBreadCrumb();
  },
  mounted() {
    this.getBanner();
  },
  methods: {
    async getBanner() {
      let res = await this.$api.getBannerList({ type: 1 });
      this.bannerList = res.data;
      setTimeout(() => {
        this.initBannerSwiper();
      }, 10);
    },
    // 初始化banner swiper
    initBannerSwiper() {
      new window.Swiper("#banner", {
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    },
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find((ele) => {
        const firstPath = this.$route.path.split("/")[1];
        return ele.path != "/" && "/" + firstPath == ele.path;
      });
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    async getList() {
      let res = await this.$api.getNewsList(this.queryParams);
      this.list = res.data.list.map((ele) => {
        ele.imgArr = ele.newsImageUrl.split(",");
        return ele;
      });
      this.total = res.data.total;
    },
    handleCurrentChange(val) {
      this.queryParams.pageIndex = val;
      this.getList();
    },
    getDetail(item) {
      window.scrollTo({ top: 200 });
      this.$router.push("/news/newDetail/" + item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    height: 600px;
    object-fit: cover;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/news_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 120px;

    .list {
      margin-top: 40px;

      .item {
        padding: 10px;
        margin-bottom: 50px;
        cursor: pointer;

        &:hover {
          box-shadow: 0 0 10px #dcdcdc;
        }
        .info {
          margin-bottom: 30px;

          .top {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .title {
            width: 600px;
            font-size: 18px;
            font-weight: bold;
            color: $theme;
            @include ellipsis;
          }
          .time {
            font-size: 14px;
            color: #5e5d5d;
          }
          .desc {
            margin-top: 20px;
            text-indent: 2em;
            font-size: 15px;
            color: #5e5d5d;
            line-height: 30px;
            @include mutipleEllipsis(2);
          }
        }
        .post {
          display: flex;

          img {
            width: 370px;
            height: 260px;
            object-fit: cover;
            margin: 0 10px;
          }
        }
      }
    }
  }
}
@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .list {
        margin-top: 20px;

        .item {
          background-color: #fff;
          border-radius: 5px;
          box-shadow: 0 0 5px #ededed;
          margin-bottom: 20px;

          .info {
            margin-bottom: 10px;

            .title {
              width: 75%;
            }
            .desc {
              margin-top: 10px;
              font-size: 14px;
            }
          }
          .post {
            img {
              width: 31%;
              height: 80px;
              margin: 0 1%;
            }
          }
        }
      }
    }
  }
}
</style>
